import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";

export const userApi = createApi({
  reducerPath: "panelUser",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Me", "Stats", "EditWindow"],
  endpoints: (builder) => ({
    updateProfile: builder.mutation({
      query: (body) => ({ url: "/api/panel/users/update-my-profile", method: "PATCH", data: body }),
      invalidatesTags: ["Me"],
    }),
    updatePassword: builder.mutation({
      query: (body) => ({ url: "/api/panel/users/update-my-password", method: "PATCH", data: body }),
    }),
    getMyStatistics: builder.query({
      query: () => ({ url: "/api/panel/users/get-my-statistics", method: "POST", data: {} }),
      providesTags: ["Stats"],
    }),
    // Üyenin geçmiş gün düzenleme penceresi (gün); gruplardaki en esnek sınır.
    getMyEditWindow: builder.query({
      query: () => ({ url: "/api/panel/users/get-my-edit-window", method: "POST", data: {} }),
      providesTags: ["EditWindow"],
    }),
    // Kişisel kodu yenile: eski kod hemen geçersiz olur, yanıtta yeni kod döner.
    regenerateMemberCode: builder.mutation({
      query: () => ({ url: "/api/panel/users/regenerate-member-code", method: "POST", data: {} }),
    }),
    deleteAccount: builder.mutation({
      query: () => ({ url: "/api/panel/users/delete-my-account", method: "POST", data: {} }),
    }),
    addMyUserGoal: builder.mutation({
      query: (body) => ({
        url: "/api/panel/users/addMyUserGoal",
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Me"],
    }),
    updateMyUserGoal: builder.mutation({
      query: (body) => ({
        url: "/api/panel/users/updateMyUserGoal",
        method: "PATCH",
        data: body,
      }),
      invalidatesTags: ["Me"],
    }),
    deleteMyUserGoal: builder.mutation({
      query: (body) => ({
        url: "/api/panel/users/deleteMyUserGoal",
        method: "DELETE",
        data: body,
      }),
      invalidatesTags: ["Me"],
    }),
  }),
});

export const {
  useUpdateProfileMutation,
  useUpdatePasswordMutation,
  useGetMyStatisticsQuery,
  useGetMyEditWindowQuery,
  useDeleteAccountMutation,
  useRegenerateMemberCodeMutation,
  useAddMyUserGoalMutation,
  useUpdateMyUserGoalMutation,
  useDeleteMyUserGoalMutation,
} = userApi;
